/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

/* components */
import PostForm from "./PostForm";
import Page from "../../shared/Page";

import GetItem from "../../../helpers/dataProviders/getItem";

class PostFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "Post";
		this.expId = props.match.params.id ? props.match.params.id : 0;
		this.state = {
			item: null,
		};
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Create {this.indefiniteArticle} {this.label}
				</h3>
				<PostForm
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					buttonLabel={`Create ${this.label}`}
				/>
			</div>
		);
	};

	renderCopyForm = () => {
		const { item } = this.state;
		if (!item) {
			GetItem(`/posts/${this.props.match.params.id}`).then(data => this.setState({ item: data.data }));
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Copy {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<PostForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						initialValues={item}
						buttonLabel={`Create ${this.label}`}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		const { item } = this.state;
		if (!item) {
			GetItem(`/posts/${this.props.match.params.id}`).then(data => this.setState({ item: data.data }));
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Update {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<PostForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, item.id)}
						id={item.id}
						actionType="update"
						initialValues={item}
						buttonLabel={`Update ${this.label}`}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	render() {
		let content = "";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				content = "loading";
				break;
		}
		return <Page title="My Posts">{content}</Page>;
	}
}

PostFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
};

export default withRouter(PostFormWrapper);
